'use client'

import ErrorPage from '~/src/components/ErrorPage'
import NotFoundRecoveryLinks from '~/src/components/NotFoundRecoveryLinks'

/**
 * App Router 404 — renders the exact same content as `pages/404.tsx` (which
 * keeps owning unmatched URLs while both routers coexist; this takes over for
 * `notFound()` calls and unmatched URLs under app/). Next.js adds
 * `<meta name="robots" content="noindex">` to not-found pages automatically,
 * matching the pages 404's NextSeo noindex.
 */
export default function NotFound(): React.ReactElement {
  return (
    <ErrorPage
      statusCode={404}
      title='404 - Not Found'
      subtitle='Oops! The page you are looking for does not exist.'
      // Shared with pages/404.tsx — the two 404s must render the same body.
      // This is the copy that actually answers unmatched URLs today, so the
      // recovery links matter here most.
      actions={<NotFoundRecoveryLinks />}
    />
  )
}
